/* eslint-disable jira/filename-case */
export const GIC_PERSISTENT_STATE_PREFERENCE_KEY =
	'jira.user.gic.persistent.modal.view.state' as const;
export const GIC_MINI_MODAL_DISCOVERABILITY_PREFERENCE_KEY =
	'jira.user.gic.mini.modal.discoverability' as const;
